import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import React from "react";

import {vstackStyle} from "./styles";

type IVStackProps = React.ComponentProps<"div"> &
    VariantProps<typeof vstackStyle> & {testID?: string};

const VStack = React.forwardRef<React.ElementRef<"div">, IVStackProps>(
    ({className, space, reversed, testID, ...props}, ref) => {
        return (
            <div
                className={vstackStyle({space, reversed, class: className})}
                {...props}
                ref={ref}
                data-testid={testID}
            />
        );
    }
);

VStack.displayName = "VStack";

export {VStack};
